import { render, staticRenderFns } from "./leaderBoard15aug.vue?vue&type=template&id=67ce4402&scoped=true&"
import script from "./leaderBoard15aug.vue?vue&type=script&lang=js&"
export * from "./leaderBoard15aug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce4402",
  null
  
)

export default component.exports